import React from "react";

interface OfficialReferenceProps {
  title: string;
  source: string;
  href: string;
  description?: string;   // optional description text
}

export const OfficialReference: React.FC<OfficialReferenceProps> = ({
  title,
  source,
  href,
  description,
}) => {
  return (
    <div className="my-2 text-sm">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-600 dark:text-indigo-400 hover:underline"
      >
        {title}
      </a>
      <span className="text-gray-600 dark:text-gray-400"> — {source}</span>
      {description && (
        <p className="text-gray-700 dark:text-gray-300 mt-1">{description}</p>
      )}
    </div>
  );
};

export default OfficialReference;
